(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('UsefulLinksController', UsefulLinksController);

    UsefulLinksController.$inject = ['$scope'];

    function UsefulLinksController($scope) {
        var vm = this;



    }
})();
